import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.75 12.1274L3.62249 8.99988L2.5575 10.0574L6.75 14.2499L15.75 5.24988L14.6925 4.19238L6.75 12.1274Z" })
});
export default SvgCheckMark;
